import React, { Component } from 'react';
import PropTypes from 'prop-types';

import StructuredDataCourseList from 'Shared/SEO/StructuredData/CourseList';

import { mainText } from 'aegisv2/styles/colors';
import { formatProduct } from 'Jsx/Utils/buyProduct';
import { getString } from 'Utils/randomizer';
import { CourseCardV3 } from 'Shared/CourseCardV3';
import { CourseCardSkeleton } from 'Shared/CourseCardV3/skeletons';
import GroupList from '../components/GroupList';
import { CourseCardWrapper } from '../ui/CourseCardWrapper';

const CourseSkeletonWrapper = CourseCardWrapper.withComponent(
  CourseCardSkeleton,
);

// eslint-disable-next-line
class CourseList extends Component {
  render() {
    const {
      loading,
      title,
      courses,
      seeAllText,
      fullWidthButton,
      helpText,
      skeletonItems,
      onSeeMore,
      isUserLogged,
      isMobile,
      user,
      itemsPerRow,
      isOrganization,
      loadingCartButton,
      userLanguage,
    } = this.props;

    return (
      <React.Fragment>
        <StructuredDataCourseList courses={courses} />
        <GroupList
          title={title}
          seeAllText={seeAllText}
          fullWidthButton={fullWidthButton}
          helpText={helpText}
          hide={!loading && courses && !courses.length}
          onSeeMore={onSeeMore}
        >
          {loading
            ? Array.from(Array(skeletonItems)).map(() => (
                <CourseSkeletonWrapper
                  itemsPerRow={itemsPerRow}
                  key={getString()}
                />
              ))
            : courses.map(c => (
                <CourseCardWrapper
                  itemsPerRow={itemsPerRow}
                  key={c.id}
                  isMobile={isMobile}
                >
                  <CourseCardV3
                    {...c}
                    product={formatProduct(c, 'course')}
                    promoImage={c.promoImage}
                    promoImageAnimated={c.promoImageAnimated}
                    user={user}
                    isUserLogged={!!isUserLogged}
                    wishedCourseActive={c.wishedCourseActive}
                    isOrganization={isOrganization}
                    loadingCartButton={loadingCartButton}
                    userLanguage={userLanguage}
                    courseCardPage="CATALOG"
                    cardImageProps={{
                      lazyLoadProps: {
                        once: false,
                      },
                    }}
                    titleProps={{
                      color: mainText,
                    }}
                    // black friday props
                    hideButtonAddToCart
                    addToCartMainButton
                    cartMainButtonInverted
                    onImageHover
                    showProfessorPicture
                  />
                </CourseCardWrapper>
              ))}
        </GroupList>
      </React.Fragment>
    );
  }
}

CourseList.propTypes = {
  user: PropTypes.shape({}),
  loading: PropTypes.bool,
  title: PropTypes.string,
  courses: PropTypes.arrayOf(
    PropTypes.shape({
      affiliateCommission: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
      ]),
      affiliateUrl: PropTypes.string,
      buyUrl: PropTypes.string,
      discount: PropTypes.number,
      duration: PropTypes.number,
      id: PropTypes.number,
      imagePlaceholder: PropTypes.string,
      inShoppingCart: PropTypes.bool,
      isEnrolled: PropTypes.bool,
      isEnrollment: PropTypes.bool,
      level: PropTypes.shape({
        name: PropTypes.string,
      }),
      originalId: PropTypes.number,
      prices: PropTypes.shape({
        currencySymbol: PropTypes.string,
        price: PropTypes.number,
        realPrice: PropTypes.number,
      }),
      promoImage: PropTypes.string,
      score: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.number]),
      title: PropTypes.string,
      url: PropTypes.string,
      professor: PropTypes.shape({
        fullName: PropTypes.string,
      }),
    }),
  ),
  seeAllText: PropTypes.string,
  fullWidthButton: PropTypes.bool,
  helpText: PropTypes.string,
  skeletonItems: PropTypes.number,
  courseIdsOwned: PropTypes.arrayOf(PropTypes.number).isRequired,
  onSeeMore: PropTypes.func,
  removeCourseFromCart: PropTypes.func.isRequired,
  addCourseToCart: PropTypes.func.isRequired,
  userId: PropTypes.number,
  isUserLogged: PropTypes.bool,
  isMobile: PropTypes.bool,
  itemsPerRow: PropTypes.shape({
    1680: PropTypes.number,
    1440: PropTypes.number,
    1280: PropTypes.number,
    1024: PropTypes.number,
    768: PropTypes.number,
  }),
  isOrganization: PropTypes.bool,
  loadingCartButton: PropTypes.bool.isRequired,
  userLanguage: PropTypes.string.isRequired,
};

CourseList.defaultProps = {
  loading: false,
  title: null,
  courses: undefined,
  seeAllText: null,
  fullWidthButton: false,
  helpText: null,
  skeletonItems: 0,
  onSeeMore: undefined,
  userId: null,
  isUserLogged: false,
  isMobile: false,
  user: null,
  itemsPerRow: {
    1680: 4,
    1440: 3,
    1280: 3,
    1024: 3,
    768: 3,
  },
  isOrganization: false,
};

export default CourseList;
